"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontStylesToCssProp = void 0;
const getCssForStyle = (style) => {
    switch (style) {
        case "bold":
            return "font-weight: 900!important;\n";
        case "italic":
            return "font-style: italic;\n";
        case "small-caps":
            return "font-variant: small-caps;\n";
        case "underlined":
            return "text-decoration: underline;\n";
        default:
            return "";
    }
};
const fontStylesToCssProp = (styles) => {
    let cssstring = "";
    styles.map((style) => (cssstring += getCssForStyle(style)));
    return cssstring;
};
exports.fontStylesToCssProp = fontStylesToCssProp;
